import './license-info-modal.css';

import 'components/util/copyright-link/copyright-link';
